/**
 * PA7-10 Live Orders Popup - JavaScript
 */

// Array of sample orders for PA7-10
const orders = [
    { name: "Julius", location: "IN", product: "PA(7) 10 1 Bottle", time: "22 minutes ago" },
    { name: "Chris", location: "CA", product: "PA(7) 10 4 Bottles", time: "49 minutes ago" },
    { name: "Robert", location: "IL", product: "PA(7) 10 3 Bottles", time: "1 hour 18 minutes ago" },
    { name: "Nico", location: "CA", product: "PA(7) 10 1 Bottle", time: "1 hour 48 minutes ago" },
    { name: "Oral", location: "NY", product: "PA(7) 10 1 Bottle", time: "2 hours 19 minutes ago" },
    { name: "Quennel", location: "NC", product: "PA(7) 10 2 Bottles", time: "2 hours 51 minutes ago" },
    { name: "Denzel", location: "TN", product: "PA(7) 10 1 Bottle", time: "3 hours 24 minutes ago" },
    { name: "Johnny", location: "LA", product: "PA(7) 10 1 Bottle", time: "3 hours 58 minutes ago" },
    { name: "Ricardo", location: "FL", product: "PA(7) 10 2 Bottles", time: "4 hours 33 minutes ago" },
    { name: "Kentray", location: "IL", product: "PA(7) 10 1 Bottle", time: "5 hours 9 minutes ago" },
    { name: "Colt", location: "HI", product: "PA(7) 10 1 Bottle", time: "25 minutes ago" },
    { name: "Jair", location: "CA", product: "PA(7) 10 1 Bottle", time: "52 minutes ago" },
    { name: "Shuntilia", location: "AL", product: "PA(7) 10 1 Bottle", time: "1 hour 21 minutes ago" },
    { name: "Marcus", location: "MS", product: "PA(7) 10 1 Bottle", time: "1 hour 51 minutes ago" },
    { name: "Lonnie", location: "GA", product: "PA(7) 10 1 Bottle", time: "2 hours 22 minutes ago" },
    { name: "Larinza", location: "VA", product: "PA(7) 10 1 Bottle", time: "2 hours 54 minutes ago" },
    { name: "Nancy", location: "VI", product: "PA(7) 10 1 Bottle", time: "3 hours 27 minutes ago" },
    { name: "Jimmy", location: "CA", product: "PA(7) 10 1 Bottle", time: "4 hours 1 minute ago" },
    { name: "Sean", location: "CA", product: "PA(7) 10 1 Bottle", time: "4 hours 36 minutes ago" },
    { name: "Vagabond", location: "VA", product: "PA(7) 10 1 Bottle", time: "5 hours 12 minutes ago" },
    { name: "Kono", location: "TX", product: "PA(7) 10 3 Bottles", time: "35 minutes ago" },
    { name: "Ray", location: "IN", product: "PA(7) 10 1 Bottle", time: "1 hour 8 minutes ago" },
    { name: "Kevin", location: "FL", product: "PA(7) 10 1 Bottle", time: "1 hour 43 minutes ago" },
    { name: "Lamar", location: "NV", product: "PA(7) 10 3 Bottles", time: "2 hours 19 minutes ago" },
    { name: "Simeon", location: "LA", product: "PA(7) 10 1 Bottle", time: "2 hours 56 minutes ago" },
    { name: "Juan", location: "MO", product: "PA(7) 10 1 Bottle", time: "3 hours 34 minutes ago" },
    { name: "Michael", location: "FL", product: "PA(7) 10 1 Bottle", time: "4 hours 13 minutes ago" },
    { name: "Jaylen", location: "CA", product: "PA(7) 10 1 Bottle", time: "4 hours 53 minutes ago" },
    { name: "Paul", location: "MA", product: "PA(7) 10 1 Bottle", time: "5 hours 34 minutes ago" },
    { name: "Heaven", location: "FL", product: "PA(7) 10 1 Bottle", time: "6 hours 16 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/PA7_mTor_Believer_15_Day_Zoom.png?v=1733777119" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
